<template>
  <create-product-layout title="ویرایش محصول" :submitFunction="UpdateProduct"/>
</template>
<script>
import {mapActions} from 'vuex';
import CreateProductLayout from "./CreateLayout.vue";


export default {
  name: "UpdateProduct",
  components: {CreateProductLayout},
  methods: {
    ...mapActions({
      UpdateProduct: "Product/updateProduct"
    })
  }
};
</script>
<style scoped>
.direction {
  direction: rtl;
}

.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}
</style>